import LabServiceModel from "@/models/LabServiceModel";
import LaboratoryModel from "@/models/lab/LaboratoryModel";
import SampleTypeModel from "@/models/lab/SampleTypeModel";
import TestProcessModel from "@/models/lab/TestProcessModel";

export default class TestWorkflowModel extends LabServiceModel {
  modelName() {
    return 'test-workflow';
  }
  icon() {
    return 'wave-square';
  }
  routes() {
    const base_route = `${process.env.VUE_APP_LAB_REPOSITORY_URL}/api/v1/`;
    const routes = super.routes();

    routes.sampleTypeUpdate = `${base_route}${this.modelName()}/sample-type/{sample_type_id}/processes`;

    return routes;
  }
  sampleTypeUpdate(laboratory_id, sample_type_id, processes) {
    const config = {
      method: this.getMethod('update'),
      url: this.getURL(
        this.getRoute('sampleTypeUpdate'),
        { sample_type_id }
      ),
      data: {
        laboratory_id,
        sample_type_id,
        processes
      }
    };

    return this.createRequest(config).send();
  }
  defaults() {
    return {
      id: null,
      laboratory_id: null,
      laboratory: null,
      sample_type_id: null,
      sample_type: null,
      test_process_id: null,
      test_process: null,
      order: null,
      created_at: null,
      updated_at: null,
    }
  }
  mutations() {
    return {
      id: (val) => (this.nullStringMutator(val)),
      laboratory_id: (val) => (this.nullStringMutator(val)),
      name: (val) => (this.nullStringMutator(val)),
      description: (val) => (this.nullStringMutator(val)),
    }
  }
  validation() {
    return {}
  }
  getLaboratory() {
    return this.getRelatedModel(LaboratoryModel, 'laboratory');
  }
  getSampleType() {
    return this.getRelatedModel(SampleTypeModel, 'sample_type');
  }
  getTestProcess() {
    return this.getRelatedModel(TestProcessModel, 'test_process');
  }
}
